var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DURATION_TIMES, _ICON_RENDERER;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import classNames from 'classnames';

import IconAlertCircle from '../../icons/general/IconAlertCircle';
import IconBell from '../../icons/general/IconBell';
import IconClose from '../../icons/general/IconClose';
import IconInfoThin from '../../icons/general/IconInfoThin';
import IconSync from '../../icons/general/IconSync';

import './Notification.scss';

// @NOTE: We can't import these constants from ./constant.js because `react-docgen`
// can't handle imported variables appear in propTypes
// see https://github.com/reactjs/react-docgen/issues/33
var DURATION_SHORT = 'short';
var DURATION_LONG = 'long';
var TYPE_DEFAULT = 'default';
var TYPE_INFO = 'info';
var TYPE_WARN = 'warn';
var TYPE_ERROR = 'error';
var OVERFLOW_WRAP = 'wrap';

var DURATION_TIMES = (_DURATION_TIMES = {}, _defineProperty(_DURATION_TIMES, DURATION_SHORT, 5000), _defineProperty(_DURATION_TIMES, DURATION_LONG, 10000), _DURATION_TIMES);

var ICON_RENDERER = (_ICON_RENDERER = {}, _defineProperty(_ICON_RENDERER, TYPE_DEFAULT, function () {
    return React.createElement(IconBell, null);
}), _defineProperty(_ICON_RENDERER, TYPE_ERROR, function () {
    return React.createElement(IconAlertCircle, null);
}), _defineProperty(_ICON_RENDERER, TYPE_INFO, function () {
    return React.createElement(IconSync, null);
}), _defineProperty(_ICON_RENDERER, TYPE_WARN, function () {
    return React.createElement(IconInfoThin, null);
}), _ICON_RENDERER);

var messages = defineMessages({
    clearNotificationButtonText: {
        'id': 'boxui.notification.clearNotification',
        'defaultMessage': 'Clear Notification'
    }
});

var Notification = function (_React$Component) {
    _inherits(Notification, _React$Component);

    function Notification() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Notification);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function (event) {
            var onClose = _this.props.onClose;

            if (_this.timeout) {
                clearTimeout(_this.timeout);
            }
            if (onClose) {
                onClose(event);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Notification, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                duration = _props.duration,
                onClose = _props.onClose;

            this.timeout = duration && onClose ? setTimeout(onClose, DURATION_TIMES[duration]) : null;
        }
    }, {
        key: 'getChildren',
        value: function getChildren() {
            var children = this.props.children;

            return typeof children === 'string' ? React.createElement(
                'span',
                null,
                children
            ) : children;
        }
    }, {
        key: 'render',
        value: function render() {
            var contents = this.getChildren();
            var _props2 = this.props,
                intl = _props2.intl,
                type = _props2.type,
                overflow = _props2.overflow;
            var formatMessage = intl.formatMessage;

            var classes = classNames('notification', type, overflow);

            return React.createElement(
                'div',
                { className: classes },
                React.cloneElement(ICON_RENDERER[type](), {
                    color: '#fff',
                    height: 20,
                    width: 20
                }),
                contents,
                React.createElement(
                    'button',
                    {
                        className: 'close-btn',
                        onClick: this.onClose,
                        'aria-label': formatMessage(messages.clearNotificationButtonText)
                    },
                    React.createElement(IconClose, { color: '#FFF', width: 18, height: 18 })
                )
            );
        }
    }]);

    return Notification;
}(React.Component);

Notification.defaultProps = {
    overflow: OVERFLOW_WRAP,
    type: TYPE_DEFAULT
};
Notification.propTypes = {
    /**
     * The contents of the `Notification`.
     * - Notification text must be wrapped in a `<span />` tag.
     * - Notification buttons must be the `<Button />` component.
     */
    children: PropTypes.node.isRequired,

    /** Function that gets executed when close button is clicked or when duration expires. */
    onClose: PropTypes.func,

    /** `duration`: When set, dictates how long the notification will exist before calling `onClose`.
     *  If unset, the notification will not automatically call `onClose`.
     * - `short`: 5s
     * - `long`: 10s */
    duration: PropTypes.oneOf(['short', 'long']),
    intl: PropTypes.object.isRequired,

    /**
     * Determines notification colors
     * - `default`: black
     * - `info`: green
     * - `warn`: yellow
     * - `error`: red
     */
    type: PropTypes.oneOf(['default', 'info', 'warn', 'error']).isRequired,
    overflow: PropTypes.oneOf(['wrap', 'ellipsis'])
};


export default injectIntl(Notification);
import PropTypes from 'prop-types';